/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import {
  Button,
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue,
  Card,
  CardContent
} from "@repo/ui";
import { RefreshCcw } from "lucide-react";
import ProgressBarChart from "./progress-bar-chart";
import PieChart from "components/pieChart";
import MultipleStackedBarChart from "../../components/multipleStackedBarCharts";
import SemiCircleRadialChart from "../../components/semiCircleRadialChart";
import type { MultiSelectChangeEvent } from "@progress/kendo-react-dropdowns";

import { ACTIVITY_TYPES } from "utils/constant";
import {
  useGetAssignmentGroups,
  useGetCustomers,
  useGetFieldEngineers,
  useGetRegions
} from "utils/apis/lookups.api";
import {
  useGetSLADashboardOverview,
  useGetSLADashboardResponseOverview,
  useSaveDashboardFilter,
  useGetDashboardFilter
} from "utils/apis/sla-dashboard.api";
import {
  useDashboardOptions,
  handleDashboardNavigation
} from "./common/dashboard-selection";
import { generateDetailLink } from "./common/generate-detail-link";
import OverviewFilters from "components/dashboardFilters/OverviewFilters";
import ResponseFilters from "components/dashboardFilters/ResponseFilters";

/* ---------------- Date Presets ---------------- */
const DATE_PRESETS = [
  { id: "all", name: "All" },
  { id: "today", name: "Today" },
  { id: "yesterday", name: "Yesterday" },
  { id: "thisweek", name: "This Week" },
  { id: "lastweek", name: "Last Week" },
  { id: "thismonth", name: "This Month" },
  { id: "lastmonth", name: "Last Month" },
  { id: "last6months", name: "Last 6 Months" },
  { id: "last9months", name: "Last 9 Months" },
  { id: "last12months", name: "Last 12 Months" }
];

interface Customer {
  customerId: string;
  customerName: string;
}

interface FieldEngineer {
  employeeId: string;
  name: string;
  nationality: string;
  cenconId: string;
}
/* ---------------- Static Field Engineers ---------------- */
// const FIELD_ENGINEERS = [{ id: "All", name: "All" }];

export default function SLADashboard() {
  const navigate = useNavigate();
  const { data: assignmentGroups } = useGetAssignmentGroups();
  const { data: fieldEngineer } = useGetFieldEngineers();
  const { data: customers } = useGetCustomers();
  const { data: regions } = useGetRegions("UAE");
  const [searchParams, setSearchParams] = useSearchParams();
  const DASHBOARD_NAME = "FLM SLA Overview 1";

  const { mutate: fetchDashboardFilter, data: savedFilter } =
    useGetDashboardFilter();
  const { mutate: saveDashboardFilter } = useSaveDashboardFilter();
  const dashboardOptions = useDashboardOptions();
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    fetchDashboardFilter(DASHBOARD_NAME);
  }, []);

  const syncOverviewFiltersToUrl = (
    date: string | undefined,
    assignmentGroups: string[],
    fieldEngineer: string[]
  ) => {
    const params = new URLSearchParams(window.location.search);

    if (date) params.set("overviewDate", date);
    else params.delete("overviewDate");
    if (assignmentGroups.length)
      params.set("assignmentGroups", assignmentGroups.join(","));
    else params.delete("assignmentGroups");

    if (fieldEngineer.length)
      params.set("fieldEngineer", fieldEngineer.join(","));
    else params.delete("fieldEngineer");

    setSearchParams(params, { replace: true });
  };

  const syncResponseFiltersToUrl = (
    date?: string,
    customers?: string[],
    activityTypes?: string[]
  ) => {
    const params = new URLSearchParams(searchParams);

    if (date) params.set("responseDate", date);
    else params.delete("responseDate");

    if (customers?.length) params.set("customers", customers.join(","));
    else params.delete("customers");

    if (activityTypes?.length)
      params.set("activityTypes", activityTypes.join(","));
    else params.delete("activityTypes");

    setSearchParams(params, { replace: true });
  };

  const { mutate: fetchOverview, data: overview } =
    useGetSLADashboardOverview();
  const { mutate: fetchResponseOverview, data: responseOverview } =
    useGetSLADashboardResponseOverview();

  /* ---------------- Filters ---------------- */
  type DatePreset = { id: string; name: string };
  type FiltersState = { date?: DatePreset; [key: string]: any };

  const [overviewFilters, setOverviewFilters] = useState<FiltersState>({
    date: DATE_PRESETS[0]
  });
  const [selectedGroups, setSelectedGroups] = useState<{ name: string }[]>([]);
  const [selectedFieldEngineers, setSelectedFieldEngineers] = useState<
    FieldEngineer[]
  >([]);
  const selectedAssignmentGroupNames = selectedGroups.map((g) => g.name);
  const [selectedDashboard, setSelectedDashboard] = useState<string>(
    "SLA Performance Dashboard"
  );

  const [responseFilters, setResponseFilters] = useState<FiltersState>({
    date: DATE_PRESETS[0]
  });
  const [selectedCustomers, setSelectedCustomers] = useState<any[]>([]);
  const [selectedActivityTypes, setSelectedActivityTypes] = useState<any[]>([]);
  const [selectedAccounts, setSelectedAccounts] = useState<any[]>([]);
  const [selectedRegions, setSelectedRegions] = useState<any[]>([]);

  /* ---------------- Helper Functions ---------------- */
  const updateOverviewFilter = (key: string, value?: any) => {
    setOverviewFilters((prev: any) => {
      const copy = { ...prev };
      if (!value) delete copy[key];
      else copy[key] = value;
      return copy;
    });
  };

  const updateResponseFilter = (key: string, value?: any) => {
    setResponseFilters((prev: any) => {
      const copy = { ...prev };
      if (!value) delete copy[key];
      else copy[key] = value;
      return copy;
    });
  };

  const handleDashboardChange = (value: string) => {
    setSelectedDashboard(value);
    handleDashboardNavigation(value, navigate, dashboardOptions);
  };

  const handleRefresh = () => {
    const overviewPayload = {
      datePreset: overviewFilters.date?.id ?? "all",
      assignmentGroups: selectedGroups.map((g) => g.name),
      fieldEngineer: selectedFieldEngineers.some((f) => f.employeeId === "all")
        ? []
        : selectedFieldEngineers.map((f) => f.employeeId),
      customers: selectedAccounts.map((c) => c.customerId),
      regions: selectedRegions.map((r) => r.name)
    };

    const responsePayload = {
      datePreset: responseFilters.date?.id ?? "all",
      activityTypes: selectedActivityTypes.map((a) => a.id),
      customers: selectedCustomers.map((c) => c.customerId)
    };

    fetchOverview(overviewPayload);
    fetchResponseOverview(responsePayload);
  };
  const handleApplyOverviewFilters = () => {
    const assignmentGroupsSel = selectedGroups.map((g) => g.name);
    const fieldEngineer = selectedFieldEngineers.map((f) => f.employeeId);
    const customersSel = selectedAccounts.map((c) => c.customerId);
    const regionsSel = selectedRegions.map((r) => r.name);

    fetchOverview({
      datePreset: overviewFilters.date?.id ?? "all",
      assignmentGroups: assignmentGroupsSel,
      fieldEngineer: fieldEngineer.includes("all") ? [] : fieldEngineer,
      customers: customersSel,
      regions: regionsSel
    });

    saveDashboardFilter({
      DashboardName: DASHBOARD_NAME,
      Filters: {
        AssignmentGroups: assignmentGroupsSel,
        DatePreset: overviewFilters.date?.id,
        FieldEngineer: fieldEngineer,
        Customers: selectedCustomers.map((c) => c.customerId),
        ActivityTypes: selectedActivityTypes.map((a) => a.id),
        Accounts: customersSel,
        Regions: regionsSel
      }
    });
  };

  const handleApplyResponseFilters = () => {
    const customersSel = selectedCustomers.map((c) => c.customerId);
    const activityTypes = selectedActivityTypes.map((a) => a.id);

    fetchResponseOverview({
      datePreset: responseFilters.date?.id ?? "all",
      activityTypes,
      customers: customersSel
    });

    saveDashboardFilter({
      DashboardName: DASHBOARD_NAME,
      Filters: {
        AssignmentGroups: selectedGroups.map((g) => g.name),
        DatePreset: overviewFilters.date?.id,
        FieldEngineer: selectedFieldEngineers.map((f) => f.employeeId),
        Customers: customersSel,
        ActivityTypes: activityTypes,
        Accounts: selectedAccounts.map((c) => c.customerId),
        Regions: selectedRegions.map((r) => r.name)
      }
    });
  };

  const handleClearOverviewFilters = () => {
    setOverviewFilters({ date: DATE_PRESETS[0] });
    setSelectedGroups([]);
    setSelectedFieldEngineers([]);
    setSelectedAccounts([]);
    setSelectedRegions([]);

    fetchOverview({
      datePreset: "all",
      assignmentGroups: [],
      fieldEngineer: [],
      customers: [],
      regions: []
    });

    saveDashboardFilter({
      DashboardName: DASHBOARD_NAME,
      Filters: {
        AssignmentGroups: [],
        DatePreset: "all",
        FieldEngineer: [],
        Customers: selectedCustomers.map((c) => c.customerId),
        ActivityTypes: selectedActivityTypes.map((a) => a.id),
        Accounts: [],
        Regions: []
      }
    });
  };

  const handleClearResponseFilters = () => {
    setResponseFilters({ date: DATE_PRESETS[0] });
    setSelectedCustomers([]);
    setSelectedActivityTypes([]);

    fetchResponseOverview({
      datePreset: "all",
      activityTypes: [],
      customers: []
    });

    saveDashboardFilter({
      DashboardName: DASHBOARD_NAME,
      Filters: {
        AssignmentGroups: selectedGroups.map((g) => g.name),
        DatePreset: overviewFilters.date?.id,
        FieldEngineer: selectedFieldEngineers.map((f) => f.employeeId),
        Customers: [],
        ActivityTypes: [],
        Accounts: selectedAccounts.map((c) => c.customerId),
        Regions: selectedRegions.map((r) => r.name)
      }
    });
  };

  useEffect(() => {
    if (
      !savedFilter?.data?.filters ||
      !assignmentGroups?.data?.length ||
      !fieldEngineer?.length ||
      !customers?.data?.length
    )
      return;
    const filters = savedFilter?.data?.filters;
    /* ---------- Overview Filters ---------- */
    if (filters?.DatePreset) {
      const matchedDate = DATE_PRESETS.find((d) => d.id === filters.DatePreset);
      if (matchedDate) {
        setOverviewFilters({ date: matchedDate });
      }
    }

    if (filters?.AssignmentGroups?.length) {
      const matchedGroups = assignmentGroups?.data?.filter((g: any) =>
        filters.AssignmentGroups.includes(g.name)
      );
      setSelectedGroups(matchedGroups);
    }

    if (filters?.FieldEngineer?.length) {
      const matchedFEs = fieldEngineer.filter((f: any) =>
        filters.FieldEngineer.includes(f.employeeId)
      );
      setSelectedFieldEngineers(matchedFEs);
    }

    /* ---------- Response Filters ---------- */
    if (filters?.Customers?.length) {
      const matchedCustomers = customers?.data?.filter((c: any) =>
        filters.Customers.includes(c.customerId)
      );
      setSelectedCustomers(matchedCustomers);
    }

    if (filters?.ActivityTypes?.length) {
      const matchedActivities = ACTIVITY_TYPES.filter((a) =>
        filters.ActivityTypes.includes(a.id)
      );
      setSelectedActivityTypes(matchedActivities);
    }
    if (filters?.Accounts?.length) {
      const matchedAccounts = customers?.data?.filter((c: any) =>
        filters.Accounts.includes(c.customerId)
      );
      setSelectedAccounts(matchedAccounts);
    }
    if (filters?.Regions?.length) {
      const matchedRegions = regions?.data?.filter((r: any) =>
        filters.Regions.includes(r.name)
      );
      setSelectedRegions(matchedRegions);
    }
    setIsHydrated(true);
  }, [savedFilter?.data, assignmentGroups, fieldEngineer, customers, regions]);

  useEffect(() => {
    if (!isHydrated) return;

    const overviewPayload = {
      datePreset: overviewFilters.date?.id ?? "all",
      assignmentGroups: selectedGroups.map((g) => g.name),
      fieldEngineer: selectedFieldEngineers.some((f) => f.employeeId === "all")
        ? []
        : selectedFieldEngineers.map((f) => f.employeeId),
      customers: selectedAccounts.map((c) => c.customerId),
      regions: selectedRegions.map((r) => r.name)
    };

    const responsePayload = {
      datePreset: responseFilters.date?.id ?? "all",
      activityTypes: selectedActivityTypes.map((a) => a.id),
      customers: selectedCustomers.map((c) => c.customerId)
    };

    fetchOverview(overviewPayload);
    fetchResponseOverview(responsePayload);
  }, [isHydrated]);

  /* ---------------- Chart Data ---------------- */
  const responseByAssignmentGroup =
    overview?.data?.caseTaskResponseOverview_ByAssignmentGroup || [];
  const resolutionByAssignmentGroup =
    overview?.data?.caseTaskResolutionOverview_ByAssignmentGroup || [];

  const responseCategories = responseByAssignmentGroup.map(
    (item: any) => item.AssignmentGroup
  );
  const resolutionCategories = resolutionByAssignmentGroup.map(
    (item: any) => item.AssignmentGroup
  );

  const responseSeries = [
    {
      name: "Within SLA",
      data: responseByAssignmentGroup.map((i: any) => i.NonBreached)
    },
    {
      name: "Breached",
      data: responseByAssignmentGroup.map((i: any) => i.Breached)
    }
  ];
  const resolutionSeries = [
    {
      name: "Within SLA",
      data: resolutionByAssignmentGroup.map((i: any) => i.NonBreached)
    },
    {
      name: "Breached",
      data: resolutionByAssignmentGroup.map((i: any) => i.Breached)
    }
  ];

  const responseByCustomer =
    responseOverview?.data?.responseOverview_ByCustomer || [];
  const responseByCustomerCategories = responseByCustomer.map(
    (item: any) => item.CustomerName
  );

  const responseByCustomerIdMap = responseByCustomer.reduce(
    (acc: Record<string, string>, item: any) => {
      acc[item.CustomerName] = item.CustomerId;
      return acc;
    },
    {}
  );

  const responseByCustomerSeries = [
    {
      name: "Within SLA",
      data: responseByCustomer.map((i: any) => i.NonBreached)
    },
    { name: "Breached", data: responseByCustomer.map((i: any) => i.Breached) }
  ];

  const responseByActivityType =
    responseOverview?.data?.responseOverview_ByActivityType || [];
  const responseByActivityTypeCategories = responseByActivityType.map(
    (item: any) => item.Group
  );
  const responseByActivityTypeSeries = [
    {
      name: "Within SLA",
      data: responseByActivityType.map((i: any) => i.NonBreached)
    },
    {
      name: "Breached",
      data: responseByActivityType.map((i: any) => i.Breached)
    }
  ];

  /* ---------------- UI ---------------- */
  return (
    <div className="px-4 pb-4 dashboard-container overflow-scroll">
      {/* ---------------- Overview Filters ---------------- */}
      <div className="flex gap-3 items-center justify-between">
        <OverviewFilters
          DATE_PRESETS={DATE_PRESETS}
          overviewFilters={overviewFilters}
          selectedGroups={selectedGroups}
          selectedFieldEngineers={selectedFieldEngineers}
          selectedAccounts={selectedAccounts}
          selectedRegions={selectedRegions}
          assignmentGroups={assignmentGroups?.data}
          fieldEngineer={fieldEngineer}
          customers={customers?.data}
          regions={regions?.data}
          setSelectedGroups={setSelectedGroups}
          setSelectedFieldEngineers={(v: any) => {
            setSelectedFieldEngineers(v);
          }}
          setSelectedAccounts={setSelectedAccounts}
          setSelectedRegions={setSelectedRegions}
          updateOverviewFilter={updateOverviewFilter}
          syncOverviewFiltersToUrl={syncOverviewFiltersToUrl}
          handleApplyOverviewFilters={handleApplyOverviewFilters}
          handleClearOverviewFilters={handleClearOverviewFilters}
        />
        <div className="flex items-center gap-2">
          <Select
            onValueChange={handleDashboardChange}
            value={selectedDashboard}
          >
            <SelectTrigger className="w-[25vw]">
              <SelectValue placeholder="Select Dashboard" />
            </SelectTrigger>
            <SelectContent className="dashboard-container">
              {dashboardOptions.map((item) => (
                <SelectItem key={item.label} value={item.label}>
                  {item.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <Button
            variant="secondary"
            onClick={handleRefresh}
            title="Refresh Dashboard"
          >
            <RefreshCcw size={16} />
          </Button>
        </div>
      </div>

      {/* ---------------- Main Charts ---------------- */}

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 p-4">
        {/* Left: PieCharts */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Card className="bg-white shadow-md rounded-lg hover:shadow-lg transition-shadow">
            <CardContent className="p-5 cursor-pointer">
              <div className="mb-3 font-semibold text-lg text-gray-800">
                Response SLA Overview
              </div>
              <PieChart
                data={[
                  {
                    status: "Within SLA",
                    count:
                      overview?.data
                        ?.caseTaskResponseOverview_BreachedNonBreached
                        ?.NonBreached || 0
                  },
                  {
                    status: "Breached",
                    count:
                      overview?.data
                        ?.caseTaskResponseOverview_BreachedNonBreached
                        ?.Breached || 0
                  }
                ]}
                label="status"
                series="count"
                onSliceClick={({ label }) => {
                  navigate(
                    generateDetailLink({
                      scope: "overview",
                      params: {
                        eventType: "Response",
                        title: `Response SLA ${label}`,
                        isBreached: label === "Breached",
                        assignmentGroup: selectedAssignmentGroupNames.join(","),
                        sourceDashboard: window.location.pathname
                      },
                      overviewFilters,
                      responseFilters,
                      selectedAssignmentGroupNames,
                      selectedFieldEngineers,
                      selectedAccounts,
                      selectedRegions
                    })
                  );
                }}
              />

              <div className="mt-4 flex justify-between items-center">
                <div className="bg-green-50 text-green-700 border border-green-200 px-3 py-1 rounded-md shadow-sm text-sm font-medium">
                  Within SLA:{" "}
                  {overview?.data?.caseTaskResponseOverview_BreachedNonBreached
                    ?.NonBreached || 0}
                </div>

                <div className="bg-red-50 text-red-700 border border-red-200 px-3 py-1 rounded-md shadow-sm text-sm font-medium">
                  Breached:{" "}
                  {overview?.data?.caseTaskResponseOverview_BreachedNonBreached
                    ?.Breached || 0}
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-white shadow-md rounded-lg hover:shadow-lg transition-shadow">
            <CardContent className="p-5 cursor-pointer">
              <div className="mb-3 font-semibold text-lg text-gray-800">
                Resolution SLA Overview
              </div>
              <PieChart
                data={[
                  {
                    status: "Within SLA",
                    count:
                      overview?.data
                        ?.caseTaskResolutionOverview_BreachedNonBreached
                        ?.NonBreached || 0
                  },
                  {
                    status: "Breached",
                    count:
                      overview?.data
                        ?.caseTaskResolutionOverview_BreachedNonBreached
                        ?.Breached || 0
                  }
                ]}
                label="status"
                series="count"
                onSliceClick={({ label }) => {
                  navigate(
                    generateDetailLink({
                      scope: "overview",
                      params: {
                        eventType: "Resolution",
                        title: `Resolution SLA ${label}`,
                        isBreached: label === "Breached",
                        assignmentGroup: selectedAssignmentGroupNames.join(","),
                        sourceDashboard: window.location.pathname
                      },
                      overviewFilters,
                      responseFilters,
                      selectedAssignmentGroupNames,
                      selectedFieldEngineers,
                      selectedAccounts,
                      selectedRegions
                    })
                  );
                }}
              />

              {/* Stats */}
              <div className="mt-4 flex justify-between items-center">
                <div className="bg-green-50 text-green-700 border border-green-200 px-3 py-1 rounded-md shadow-sm text-sm font-medium">
                  Within SLA:{" "}
                  {overview?.data
                    ?.caseTaskResolutionOverview_BreachedNonBreached
                    ?.NonBreached || 0}
                </div>

                <div className="bg-red-50 text-red-700 border border-red-200 px-3 py-1 rounded-md shadow-sm text-sm font-medium">
                  Breached:{" "}
                  {overview?.data
                    ?.caseTaskResolutionOverview_BreachedNonBreached
                    ?.Breached || 0}
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Right: ProgressBars + SemiCircle */}
        <div className="grid grid-cols-1 gap-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <ProgressBarChart
              title="Response SLA About To Breach"
              value={
                overview?.data?.caseTaskResponseOverview_AboutToBreach
                  ?.aboutToBreachCount || 0
              }
              valueString="About To Breach"
              totalString="Total"
              count={
                overview?.data?.caseTaskResponseOverview_BreachedNonBreached
                  ?.Total
              }
              filters={{
                date: overviewFilters.date,
                assignmentGroups: selectedAssignmentGroupNames,
                sourceDashboard: window.location.pathname
              }}
              eventType="Response"
            />
            <ProgressBarChart
              title="Resolution SLA About To Breach"
              value={
                overview?.data?.caseTaskResolutionOverview_AboutToBreach
                  ?.aboutToBreachCount || 0
              }
              valueString="About To Breach"
              totalString="Total"
              count={
                overview?.data?.caseTaskResolutionOverview_BreachedNonBreached
                  ?.Total
              }
              filters={{
                date: overviewFilters.date,
                assignmentGroups: selectedAssignmentGroupNames,
                sourceDashboard: window.location.pathname
              }}
              eventType="Resolution"
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Card className="bg-white shadow-md rounded-xl hover:shadow-xl transition-shadow duration-300">
              <Link
                to={generateDetailLink({
                  scope: "overview",
                  params: {
                    eventType: "Response",
                    status: "InProgress",
                    isBreached: true,
                    isAboutToBreach: false,
                    title: "Response SLA Breach In Progress",
                    assignmentGroup: selectedAssignmentGroupNames.join(","),
                    sourceDashboard: window.location.pathname
                  },
                  overviewFilters,
                  responseFilters,
                  selectedAssignmentGroupNames,
                  selectedFieldEngineers,
                  selectedAccounts,
                  selectedRegions
                })}
              >
                <SemiCircleRadialChart
                  title="Response SLA Breach In Progress"
                  percent={
                    overview?.data?.caseTaskResponseOverview_Breach_InProgress
                      ?.breachInProgressPercent || 0
                  }
                  count={
                    overview?.data?.caseTaskResponseOverview_Breach_InProgress
                      ?.breachInProgressCount || 0
                  }
                  total={
                    overview?.data?.caseTaskResponseOverview_Breach_InProgress
                      ?.total || 0
                  }
                />
              </Link>
            </Card>

            <Card className="bg-white shadow-md rounded-xl hover:shadow-xl transition-shadow duration-300">
              <Link
                to={generateDetailLink({
                  scope: "overview",
                  params: {
                    eventType: "Resolution",
                    status: "InProgress",
                    isBreached: true,
                    isAboutToBreach: false,
                    title: "Resolution SLA Breach In Progress",
                    assignmentGroup: selectedAssignmentGroupNames.join(","),
                    sourceDashboard: window.location.pathname
                  },
                  overviewFilters,
                  responseFilters,
                  selectedAssignmentGroupNames,
                  selectedFieldEngineers,
                  selectedAccounts,
                  selectedRegions
                })}
              >
                <SemiCircleRadialChart
                  title="Resolution SLA Breach In Progress"
                  percent={
                    overview?.data?.caseTaskResolutionOverview_Breach_InProgress
                      ?.breachInProgressPercent || 0
                  }
                  count={
                    overview?.data?.caseTaskResolutionOverview_Breach_InProgress
                      ?.breachInProgressCount || 0
                  }
                  total={
                    overview?.data?.caseTaskResolutionOverview_Breach_InProgress
                      ?.total || 0
                  }
                />
              </Link>
            </Card>
          </div>
        </div>
      </div>

      {/* ---------------- Assignment Group & Customer Charts ---------------- */}
      <div className="grid grid-cols-2 gap-6">
        <Card>
          <CardContent className="p-4 cursor-pointer">
            <div className="mb-2 font-semibold text-lg">
              Response SLA by Assignment Group
            </div>
            <MultipleStackedBarChart
              categories={responseCategories}
              series={responseSeries}
              height={350}
              onBarSliceClick={({ category, isBreached }) => {
                navigate(
                  generateDetailLink({
                    scope: "overview",
                    params: {
                      eventType: "Response",
                      assignmentGroup: category,
                      isBreached,
                      title: `Response SLA - ${category}`,
                      sourceDashboard: window.location.pathname
                    },
                    overviewFilters,
                    responseFilters,
                    selectedAssignmentGroupNames,
                    selectedFieldEngineers,
                    selectedAccounts,
                    selectedRegions
                  })
                );
              }}
            />
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-4 cursor-pointer">
            <div className="mb-2 font-semibold text-lg">
              Resolution SLA by Assignment Group
            </div>
            <MultipleStackedBarChart
              categories={resolutionCategories}
              series={resolutionSeries}
              height={350}
              onBarSliceClick={({ category, isBreached }) => {
                navigate(
                  generateDetailLink({
                    scope: "overview",
                    params: {
                      eventType: "Resolution",
                      assignmentGroup: category,
                      isBreached,
                      title: `Resolution SLA - ${category}`,
                      sourceDashboard: window.location.pathname
                    },
                    overviewFilters,
                    responseFilters,
                    selectedAssignmentGroupNames,
                    selectedFieldEngineers,
                    selectedAccounts,
                    selectedRegions
                  })
                );
              }}
            />
          </CardContent>
        </Card>
      </div>

      {/* ---------------- Response Overview Filters ---------------- */}
      <div className="flex gap-3 items-center justify-start p-4">
        <ResponseFilters
          DATE_PRESETS={DATE_PRESETS}
          responseFilters={responseFilters}
          selectedCustomers={selectedCustomers}
          selectedActivityTypes={selectedActivityTypes}
          customers={customers?.data}
          ACTIVITY_TYPES={ACTIVITY_TYPES}
          setSelectedCustomers={setSelectedCustomers}
          setSelectedActivityTypes={setSelectedActivityTypes}
          updateResponseFilter={updateResponseFilter}
          syncResponseFiltersToUrl={syncResponseFiltersToUrl}
          handleApplyResponseFilters={handleApplyResponseFilters}
          handleClearResponseFilters={handleClearResponseFilters}
        />
      </div>

      {/* ---------------- Response SLA by Customer & Activity Type ---------------- */}
      <div className="grid grid-cols-2 gap-6">
        {/* Response SLA by Customer */}
        <Card>
          <CardContent className="p-4 cursor-pointer">
            <div className="mb-2 font-semibold text-lg">
              Response SLA by Customer
            </div>
            <MultipleStackedBarChart
              categories={responseByCustomerCategories}
              series={responseByCustomerSeries}
              horizontal
              height={350}
              onBarSliceClick={({ category, isBreached }) => {
                navigate(
                  generateDetailLink({
                    scope: "response",
                    params: {
                      eventType: "Response",
                      customerId: responseByCustomerIdMap[category],
                      isBreached,
                      title: `Response SLA - ${category}`,
                      sourceDashboard: window.location.pathname
                    },
                    overviewFilters,
                    responseFilters,
                    selectedAssignmentGroupNames,
                    selectedFieldEngineers,
                    selectedAccounts,
                    selectedRegions
                  })
                );
              }}
            />
          </CardContent>
        </Card>

        {/* Response SLA by Activity Type */}
        <Card>
          <CardContent className="p-4 cursor-pointer">
            <div className="mb-2 font-semibold text-lg">
              Response SLA by Activity Type
            </div>
            <MultipleStackedBarChart
              categories={responseByActivityTypeCategories}
              series={responseByActivityTypeSeries}
              height={350}
              horizontal
              onBarSliceClick={({ category, isBreached }) => {
                navigate(
                  generateDetailLink({
                    scope: "response",
                    params: {
                      eventType: "Response",
                      activityType: category,
                      isBreached,
                      title: `Response SLA - ${category}`,
                      sourceDashboard: window.location.pathname
                    },
                    overviewFilters,
                    responseFilters,
                    selectedAssignmentGroupNames,
                    selectedFieldEngineers,
                    selectedAccounts,
                    selectedRegions
                  })
                );
              }}
            />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
